import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastController, ModalController } from '@ionic/angular';
import { AlertService } from 'src/app/services/alert.service';
import { ChangedPasswordService } from 'src/app/services/change-password.service';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.page.html',
  styleUrls: ['./change-password-modal.page.scss'],
  standalone: false
})
export class ChangePasswordModalPage implements OnInit {

  passwordForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private changedPasswordService: ChangedPasswordService,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.passwordForm = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmNewPassword: ['', Validators.required]
    });
  }

async submitPasswordChange() {
  if (this.passwordForm.invalid) {
    this.alertService.showError('Lütfen tüm alanları geçerli şekilde doldurun');
    return;
  }

  const { currentPassword, newPassword, confirmNewPassword } = this.passwordForm.value;

  if (newPassword === currentPassword) {
    this.alertService.showError('Yeni şifre eski şifre ile aynı olamaz');
    return;
  }

  if (newPassword !== confirmNewPassword) {
    this.alertService.showError('Yeni şifre ve tekrarı uyuşmuyor');
    return;
  }

if (!this.isPasswordStrong(newPassword)) {
  this.alertService.showError(
    'Yeni şifre en az 6 karakter uzunluğunda olmalı ve en az bir büyük harf, bir küçük harf, bir sayı ve bir özel karakter içermelidir.'
  );
  return;
}


  this.changedPasswordService.changePassword({ currentPassword, newPassword }).subscribe({
    next: () => {
      this.alertService.showSuccess('Şifreniz başarıyla değiştirildi');
      this.modalCtrl.dismiss(null, 'success');
    },
    error: (err) => {
      if (err?.error?.detail?.toLowerCase().includes('invalid password')) {
        this.alertService.showError('Eski şifre hatalı');
      } else {
        this.alertService.showError('Şifre değiştirme işlemi başarısız');
      }
    }
  });
}


  close() {
    this.modalCtrl.dismiss(false);
  }

  private async showToast(message: string) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color: 'primary'
    });
    toast.present();
  }
isFormValid(): boolean {
  return this.passwordForm.valid;
}

onFieldChanged(e: any) {
  const field = e.dataField;
  const value = e.value;
  this.passwordForm.get(field)?.setValue(value);
  this.passwordForm.get(field)?.markAsDirty();
  this.passwordForm.get(field)?.updateValueAndValidity();
}
private isPasswordStrong(value: string): boolean {
  const hasUpperCase = /[A-Z]/.test(value);
  const hasLowerCase = /[a-z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
  const isValidLength = value.length >= 6;

  return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength;
}


}
